// src/index.ts
var BOOKING_STEPS = {
  SEARCH: 1,
  RESULTS: 2,
  SEATS: 3,
  PASSENGERS: 4,
  PAYMENT: 5,
  CONFIRMATION: 6
};
export {
  BOOKING_STEPS
};
